/// <amd-module name="VSS/Features/Directory/components/DirectoryContentView/ContentError" />
import * as React from "react";
import { ExceptionInfo } from "../../DirectoryContracts";
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Link } from "VSSUI/Link";
import { ZeroData } from "VSSUI/Components/ZeroData";
import * as DirectoryResources from "VSS/Features/Directory/Resources";

export interface IContentErrorProps {
    exceptionsInfo: ExceptionInfo[];
}

/**
 * Renders a full page experience in the hub displaying an error image and message.
 */
export class ContentError extends VssComponent<IContentErrorProps, {}> {
    constructor(props: IContentErrorProps) {
        super(props);
    }

    public render(): JSX.Element {
        const exceptionsInfoElement: JSX.Element = (
            <div className="page-content-top">
                {this.props.exceptionsInfo.map((exceptionInfo, index) => (
                    <div key={index}>
                        {this._getErrorsList(exceptionInfo)}
                        {this._getErrorLinks(exceptionInfo)}
                    </div>
                ))}
            </div>
        );

        return (
            <div className="hub-error">
                <ZeroData
                    imagePath={getAssetLocation(this.context.pageContext, "ms.vss-features/directory/content/content-error-general.svg")}
                    imageAltText=""
                    primaryText={DirectoryResources.GeneralErrorMessage}
                    secondaryText={exceptionsInfoElement}
                />
            </div>
        );
    }

    private _getErrorsList(exceptionInfo: ExceptionInfo): JSX.Element {
        const hasErrorsList: boolean = exceptionInfo.additionalMessages ? exceptionInfo.additionalMessages.length > 0 : false;
        return (
            <div>
                <div>{exceptionInfo.exceptionMessage}</div>
                {hasErrorsList && (
                    <ul>
                        {exceptionInfo.additionalMessages!.map((e, i) => (
                            <li key={`Error${i}`}>{e}</li>
                        ))}
                    </ul>
                )}
            </div>
        );
    }

    private _getErrorLinks(exceptionInfo: ExceptionInfo): JSX.Element {
        let primaryLink: JSX.Element | undefined;
        if (exceptionInfo.primaryLinkHref && exceptionInfo.primaryLinkText) {
            primaryLink = (
                <p>
                    <Link href={exceptionInfo.primaryLinkHref}>{exceptionInfo.primaryLinkText}</Link>
                </p>
            );
        }

        let secondaryLink: JSX.Element | undefined;
        if (exceptionInfo.secondaryLinkHref && exceptionInfo.secondaryLinkText) {
            secondaryLink = (
                <p>
                    <Link href={exceptionInfo.secondaryLinkHref}>{exceptionInfo.secondaryLinkText}</Link>
                </p>
            );
        }

        return (
            <div>
                {primaryLink}
                {secondaryLink}
            </div>
        );
    }
}
